export default __webpack_public_path__ + "static/media/catherine-hughes-PkEQHH6R7Eg-unsplash.58ab1761.jpg";